import React from 'react';
import { useTranslation } from 'react-i18next';

interface Step {
    color: string;
}

const HowItWorks: React.FC = () => {
    const { t } = useTranslation();

    const stepColors: Step[] = [
        { color: "orange" },
        { color: "blue" },
        { color: "pink" },
        { color: "green" }
    ];

    return (
        <div id="how-it-works" className="how-it-works-section section-photo-gallery">
            <div className="padding-global">
                <div className="container-large">
                    <div className="padding-section-large">
                        {/* Section Header */}
                        <div className="how-it-works-header">
                            <div className="heading-wrapper">
                                <h2 className="heading-style-h2">{t('howItWorks.heading')}</h2>
                                <div className="line-color-pink" style={{ height: '14.3984px' }}></div>
                            </div>
                            <div className="padding-bottom padding-xsmall"></div>
                            <p className="text-size-small">
                                {t('howItWorks.subheading')}
                            </p>
                        </div>

                        <div className="padding-bottom padding-large"></div>

                        {/* Steps Grid */}
                        <div className="how-it-works-grid">
                            {stepColors.map((step, index) => (
                                <div
                                    key={index}
                                    className={`how-it-works-item step-${step.color}`}
                                >
                                    <div className={`step-number-badge badge-${step.color}`}>
                                        <span className="step-number">{t(`howItWorks.steps.${index}.number`)}</span>
                                    </div>
                                    <div className="step-content">
                                        <h3 className="heading-style-h3 step-title">{t(`howItWorks.steps.${index}.title`)}</h3>
                                        <p className="text-size-regular step-description">{t(`howItWorks.steps.${index}.description`)}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowItWorks;
